const StripeSecurityBadge = ({ className = '' }) => {
    return (
        <div className={`d-flex align-items-center ${className}`}>
            <span className="text-muted me-2">Secure payments by</span>
            <svg
                className="stripe-badge"
                viewBox="0 0 60 25"
                xmlns="http://www.w3.org/2000/svg"
                width="60"
                height="25"
                aria-label="Stripe"
                role="img"
            >
                <path
                    fill="#635BFF"
                    d="M59.64 14.28h-8.06v-1.84h8.05l.01 1.84ZM59.64 12.04h-8.06v-1.84h8.05l.01 1.84ZM59.64 9.8h-8.06V7.96h8.05l.01 1.84ZM59.64 7.56h-8.06V5.72h8.05l.01 1.84Z"
                />
                <path
                    fill="#635BFF"
                    d="M52.64 17.64c-1.45 0-2.62-1.17-2.62-2.62 0-1.45 1.17-2.62 2.62-2.62 1.45 0 2.62 1.17 2.62 2.62 0 1.45-1.17 2.62-2.62 2.62Zm0-4.24c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62.89 0 1.62-.72 1.62-1.62 0-.89-.72-1.62-1.62-1.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M49.13 15.02c0-1.45 1.17-2.62 2.62-2.62h1.57v1h-1.57c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62h1.57v1h-1.57c-1.45 0-2.62-1.17-2.62-2.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M37.07 17.64c-1.45 0-2.62-1.17-2.62-2.62 0-1.45 1.17-2.62 2.62-2.62 1.45 0 2.62 1.17 2.62 2.62 0 1.45-1.17 2.62-2.62 2.62Zm0-4.24c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62.89 0 1.62-.72 1.62-1.62 0-.89-.72-1.62-1.62-1.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M33.56 15.02c0-1.45 1.17-2.62 2.62-2.62h1.57v1h-1.57c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62h1.57v1h-1.57c-1.45 0-2.62-1.17-2.62-2.62ZM44.84 17.64c-1.45 0-2.62-1.17-2.62-2.62 0-1.45 1.17-2.62 2.62-2.62 1.45 0 2.62 1.17 2.62 2.62 0 1.45-1.17 2.62-2.62 2.62Zm0-4.24c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62.89 0 1.62-.72 1.62-1.62 0-.89-.72-1.62-1.62-1.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M41.33 15.02c0-1.45 1.17-2.62 2.62-2.62h1.57v1H44.1c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62h1.42v1H43.95c-1.45 0-2.62-1.17-2.62-2.62ZM29.5 17.64c-1.45 0-2.62-1.17-2.62-2.62 0-1.45 1.17-2.62 2.62-2.62 1.45 0 2.62 1.17 2.62 2.62 0 1.45-1.17 2.62-2.62 2.62Zm0-4.24c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62.89 0 1.62-.72 1.62-1.62 0-.89-.72-1.62-1.62-1.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M25.99 15.02c0-1.45 1.17-2.62 2.62-2.62h1.57v1h-1.57c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62h1.57v1h-1.57c-1.45 0-2.62-1.17-2.62-2.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M21.93 17.64c-1.45 0-2.62-1.17-2.62-2.62 0-1.45 1.17-2.62 2.62-2.62 1.45 0 2.62 1.17 2.62 2.62 0 1.45-1.17 2.62-2.62 2.62Zm0-4.24c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62.89 0 1.62-.72 1.62-1.62 0-.89-.72-1.62-1.62-1.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M18.42 15.02c0-1.45 1.17-2.62 2.62-2.62h1.57v1h-1.57c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62h1.57v1h-1.57c-1.45 0-2.62-1.17-2.62-2.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M14.36 17.64c-1.45 0-2.62-1.17-2.62-2.62 0-1.45 1.17-2.62 2.62-2.62 1.45 0 2.62 1.17 2.62 2.62 0 1.45-1.17 2.62-2.62 2.62Zm0-4.24c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62.89 0 1.62-.72 1.62-1.62 0-.89-.72-1.62-1.62-1.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M10.85 15.02c0-1.45 1.17-2.62 2.62-2.62h1.57v1h-1.57c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62h1.57v1h-1.57c-1.45 0-2.62-1.17-2.62-2.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M6.79 17.64c-1.45 0-2.62-1.17-2.62-2.62 0-1.45 1.17-2.62 2.62-2.62 1.45 0 2.62 1.17 2.62 2.62 0 1.45-1.17 2.62-2.62 2.62Zm0-4.24c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62.89 0 1.62-.72 1.62-1.62 0-.89-.72-1.62-1.62-1.62Z"
                />
                <path
                    fill="#635BFF"
                    d="M3.28 15.02c0-1.45 1.17-2.62 2.62-2.62h1.57v1H5.9c-.89 0-1.62.72-1.62 1.62 0 .89.72 1.62 1.62 1.62h1.57v1H5.9c-1.45 0-2.62-1.17-2.62-2.62Z"
                />
            </svg>
            <div className="ms-2 d-flex align-items-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-success me-1"
                >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                <span className="text-success small">Secure</span>
            </div>
        </div>
    );
};

export default StripeSecurityBadge;